import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'noImagen' })
export class NoImagenPipe implements PipeTransform {
transform(urlImg: string): string {
    if (!urlImg || urlImg.trim() === '' || urlImg === 'No_Disponible') {
      return 'assets/img/complemento-web/not-image.png';
    }
    return urlImg;
  }
}